/**
 * The 18px retailer mark beside a ladder row. Marks live in
 * public/homepage-2026/retailers/; a retailer without a mark shows a neutral
 * initial tile — never a wrong logo.
 */
export const RETAILER_MARKS: Record<string, string> = {
  'brandsmart usa': 'retailer-brandsmartusa.png',
  amazon: 'retailer-amazon.png',
  amana: 'retailer-amana.svg',
  'aj madison': 'retailer-ajmadison.png',
  'lg electronics': 'retailer-lg.png',
  lg: 'retailer-lg.png',
  'abt electronics': 'retailer-abt.png',
  abt: 'retailer-abt.png',
  'best buy': 'retailer-bestbuy.png',
  wayfair: 'retailer-wayfair.png',
  "sam's club": 'retailer-samsclub.png',
}

export function RetailerMark({ name }: { name: string }) {
  const file = RETAILER_MARKS[name.trim().toLowerCase()]
  if (file) {
    // eslint-disable-next-line @next/next/no-img-element -- 18px static mark from /public; next/image adds nothing here
    return <img className={`retlogo${file === 'retailer-amana.svg' ? ' retlogo-amana' : ''}`} src={`/homepage-2026/retailers/${file}`} alt="" width={18} height={18} />
  }
  return (
    <span className="retlogo" aria-hidden="true" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: '#f2f4f7', color: '#364152', fontSize: 10, fontWeight: 800 }}>
      {name.trim().slice(0, 1).toUpperCase()}
    </span>
  )
}
